// Copyright (c) Move Closer 2022.

import { ConnectorMiddleware, FoundResource, Headers, Injectable, IResponse, Payload } from '@movecloser/front-core'

import { ISessionService } from './session.service'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
@Injectable()
export class SessionMiddleware implements ConnectorMiddleware {
  constructor (private readonly sessionService: ISessionService) {

  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public afterCall (response: IResponse, resource: FoundResource): void {
    // Do nothing
  }

  public beforeCall (
    resource: FoundResource,
    headers: Headers,
    body: Payload
  ): { headers: Headers; body: Payload } | Promise<{ headers: Headers; body: Payload }> {
    if (this.sessionService.sessionToken) {
      headers['X-Session'] = this.sessionService.sessionToken
    }

    return { headers, body }
  }
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const SessionMiddlewareType = Symbol.for('ISessionMiddleware')
